<template>
  <router-view />
    <notifications group="main" style="padding-top: 90px;"/>
</template>

<script>


export default {
  name: 'DashboardMain',
  mounted() {
    import('bootstrap/dist/css/bootstrap.css')
    import("bootstrap")
  }
}
</script>

<style>
#app {
  * {
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
  }

  body {
    font-family: "LatoRegular","Lucida Grande",Tahoma,Sans-Serif;
    font-size: 16px;
    color: #333;

    //font-family: 'Open Sans', serif; font-family: 'Roboto', sans-serif;
    //font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}
</style>
